import Helper from './Helper';

class Video {
  constructor() {
    const playbutton = Array.prototype.slice.call(document.querySelectorAll('.ns-video__thumbnail'));
    playbutton.forEach(button =>{
      button.addEventListener('click', () => {
        const video = button.parentElement;
        const thumbnail = button;
        const iframe = video.querySelector('iframe');
        iframe.src = iframe.src + '?autoplay=1';
        thumbnail.classList.add('fade-out');
        thumbnail.style.display = 'none';
      });
    });
  }
} export default Video;
